import { FormControl } from "@mui/material";
import { Controller } from "react-hook-form";
import { SelectWithFilter } from "../";
import _ from "lodash";

const FormSelectWithFilter = props => {
  const { control, name, required, pattern, validate, ...otherProps } = props;
  return <FormControl fullWidth>
    <Controller
      control={control}
      name={name}
      rules={{
        required,
        pattern,
        validate
      }}
      render={({
        field: { value, onChange },
        fieldState: { error }
      }) => (
        <>
          <SelectWithFilter
            onChange={onChange}
            error={error}
            freeSolo
            value={value}
            name={name}
            required={required}
            {...otherProps}
          />
        </>
      )}
    />
  </FormControl>
};

export default FormSelectWithFilter;
